import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ContainerComponent } from '../../../shared/components/container/container.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';
import { DecoratorComponent } from '../../../shared/components/decorator/decorator.component';
import { appPaths } from '../../../app.paths';

@Component({
  selector: '[what-is-screen]',
  imports: [ContainerComponent, RouterModule, PictureComponent, DecoratorComponent],
  templateUrl: './what-is-screen.component.html',
  styleUrl: './what-is-screen.component.scss',
  host: {
    class: 'bg-gray-800 position-relative z-0'
  }
})
export class WhatIsScreenComponent {
  appPaths = appPaths;
  
  decorator = {
    firstLineColor: '#ff5e2b',
    secondLineColor: '#9657d6',
  }
}
